<template>
    <artmisads-modal class="link-tool" :width="800" v-model:open="open" :footer="null" :maskClosable="false"
        :bodyStyle="{ padding: '24px 24px 12px' }">
        <template #title>
            <span class="title">Generate a Link</span>
        </template>
        <div>
            <a-spin :spinning="loading">
                <artmisads-segmented-tabs :showTitle="false" v-model="activeTab" :items="programConfig" />
                <div class="source" v-if="activeTab === '1'" style="margin-bottom: 20px;">
                    <div class="source-options">
                        <p class="sub-title">
                            <span>Select Associate Tag</span>
                        </p>
                        <div class="option-item" ref="associateTag" style="display: flex;align-items: center;gap:16px">
                            <a-select :getPopupContainer="() => $refs.associateTag" placeholder=""
                                :dropdownMatchSelectWidth="200" class="source-select artmisads-select" allowClear
                                v-model:value="associateModelRef.associateTag" :options="associateTagOptions"
                                @dropdownVisibleChange="onFocusAssociateTag"
                                @change="onChangeAssociateTag" ref="sourceSelect">
                                <template #dropdownRender="{ menuNode: menu }">
                                    <v-nodes :vnodes="menu" />
                                    <div v-if="!associateTagOptions||associateTagOptions?.length === 0">
                                        <a-divider style="margin: 8px 0" />
                                        <div class="upload-associate-tag">
                                            <artmisads-button :isSquare="true" size="small" type="primary"
                                                @click="onUploadAssociateTag" >
                                                Upload Associate Tag
                                            </artmisads-button>
                                        </div>
                                    </div>
                                </template>
                            </a-select>
                            <artmisads-button class="generate-btn" type="primary"
                                :disabled="!associateModelRef.associateTag" @click="onGenerateAssociateLink">
                                Generate
                            </artmisads-button>
                        </div>
                    </div>
                </div>

                <div class="link-scroll-area">
                    <div class="link-textarea" v-if="activeTab === '0'">
                        {{ modelRef.shortLinkSelect ? modelRef.shortLink : showTrackLink }}
                    </div>
                    <div class="link-textarea" v-if="activeTab === '1'">
                        {{ associateModelRef.shortLinkSelect ? associateModelRef.shortLink :
                            associateModelRef.associateLink }}
                    </div>
                </div>
                <div class="link-short-link">
                    <a-checkbox
                        :checked="activeTab === '0' ? modelRef.shortLinkSelect : associateModelRef.shortLinkSelect"
                        @update:checked="val => activeTab === '0' ? modelRef.shortLinkSelect = val : associateModelRef.shortLinkSelect = val">Short
                        Link</a-checkbox>
                </div>
                <a-collapse ghost class="link-collapse" v-if="false" v-model:activeKey="activeKey">
                    <a-collapse-panel key="collapse" :showArrow="false">
                        <template #header>
                            <div class="link-collapse-header">
                                <span>Advanced Options</span>
                                <svg class="icon" aria-hidden="true">
                                    <use xlink:href="#icon-jiantou-xia-cu"></use>
                                </svg>
                            </div>
                        </template>
                        <div class="link-advanced-option">
                            <div>
                                <p class="sub-title">
                                    <span>Amazon tracking tag:</span>
                                </p>
                                <div class="option-item">
                                    <a-radio-group v-model:value="modelRef.amazonTagSelect" class="tracking-tag">
                                        <a-radio value="default">
                                            <span>Use your default Amazon tracking tag</span>
                                        </a-radio>
                                        <a href="/publisher/settings/profile" target="_blank">Set defalut Amazon
                                            tracking
                                            tag</a>
                                        <a-radio value="specific">
                                            <span>Use Speciﬁc Amazon tracking tag</span>
                                        </a-radio>
                                    </a-radio-group>
                                    <input class="track-tag-input" :maxlength="15" ref="trackTagInput"
                                        :disabled="modelRef.amazonTagSelect != 'specific'" v-model="modelRef.tag"
                                        @input="onTrackTagInput" />
                                </div>
                            </div>
                            <div style="margin-top: 32px">
                                <!-- Source Options -->
                                <p class="sub-title" ref="optionTip">
                                    <span>Source Options</span>
                                    <a-tooltip :getPopupContainer="() => $refs.optionTip">
                                        <template #title>
                                            A source is a method of classifying your links. For instance, a typical one
                                            could be
                                            a speciﬁc article ID or a domain name. You'll be capable of viewing a
                                            reporting
                                            breakdown for every source.
                                        </template>
                                        <svg class="icon" aria-hidden="true">
                                            <use xlink:href="#icon-wenhao-tianchong"></use>
                                        </svg>
                                    </a-tooltip>
                                </p>
                                <div class="option-item" ref="se">
                                    <a-select :disabled="trackLinkId" :getContainer="() => $refs.se" placeholder="All"
                                        class="source-select artmisads-select" v-model:value="modelRef.sourceId"
                                        :options="sourceOptions" ref="sourceSelect" :open="sourceSelectOpen"
                                        @dropdownVisibleChange="visible => sourceSelectOpen = visible"
                                        :dropdownStyle="{ overflow: 'unset' }" @change="onChangeTrackLink">
                                        <template #dropdownRender="{ menuNode: menu }">
                                            <v-nodes :vnodes="menu" />
                                            <a-divider style="margin: 8px 0" />
                                            <Editable :allow-clear="true" @callback="onAddSourceOption"
                                                :style="{ margin: '0 auto' }" v-model:close="sourceSelectOpen">
                                                <template #default="slotProps">
                                                    <a href="javascript:;" class="source-edit"
                                                        @click="slotProps.onClick">
                                                        <svg class="icon" aria-hidden="true"
                                                            style="font-size: 16px; margin-right: 8px;">
                                                            <use xlink:href="#icon-jiahao-cu"></use>
                                                        </svg>
                                                        <span>New Source</span>
                                                    </a>
                                                </template>
                                            </Editable>
                                        </template>
                                        <template #suffixIcon>
                                            <svg class="icon" aria-hidden="true">
                                                <use xlink:href="#icon-jiantou-xia-cu"></use>
                                            </svg>
                                        </template>
                                    </a-select>
                                </div>

                            </div>
                        </div>
                    </a-collapse-panel>
                </a-collapse>
                <div class="source" v-if="activeTab === '0'">

                    <!-- Primary Tracking ID(Optional) -->
                    <div class="source-options">
                        <p class="sub-title">
                            <span>Primary Tracking ID(Optional)</span>
                        </p>
                        <div class="option-item" ref="primaryTracking">
                            <a-select :disabled="trackLinkId" :getPopupContainer="() => $refs.primaryTracking"
                                placeholder="" class="source-select artmisads-select"
                                v-model:value="modelRef.primaryTrackingId" :options="primaryTrackingIdOptions"
                                ref="sourceSelect" :open="primarySourceSelectOpen"
                                @dropdownVisibleChange="visible => primarySourceSelectOpen = visible"
                                :dropdownStyle="{ overflow: 'unset' }" @change="onChangePrimaryTrackingId">
                                <template #dropdownRender="{ menuNode: menu }">
                                    <v-nodes :vnodes="menu" />
                                    <a-divider style="margin: 8px 0" />
                                    <Editable :allow-clear="true" @callback="onAddPrimaryTrackingId"
                                        :style="{ margin: '0 auto 4px' }" v-model:close="sourceSelectOpen">
                                        <template #default="slotProps">
                                            <a href="javascript:;" class="source-edit" @click="slotProps.onClick">
                                                <svg class="icon" aria-hidden="true"
                                                    style="font-size: 16px; margin-right: 8px;">
                                                    <use xlink:href="#icon-jiahao-cu"></use>
                                                </svg>
                                                <span>New Primary Tracking ID</span>
                                            </a>
                                        </template>
                                    </Editable>
                                </template>
                                <template #suffixIcon>
                                    <svg class="icon" aria-hidden="true">
                                        <use xlink:href="#icon-jiantou-xia-cu"></use>
                                    </svg>
                                </template>
                            </a-select>
                        </div>
                    </div>
                    <!-- Sub Tracking ID(Optional) -->
                    <div class="source-options">
                        <p class="sub-title">
                            <span>Sub Tracking ID(Optional)</span>
                        </p>
                        <div class="option-item" ref="subTracking">
                            <a-select :disabled="trackLinkId" :getPopupContainer="() => $refs.subTracking"
                                placeholder="" class="source-select artmisads-select"
                                v-model:value="modelRef.subTrackingId" :options="subTrackingIdOptions"
                                ref="sourceSelect" :open="subSourceSelectOpen"
                                @dropdownVisibleChange="visible => subSourceSelectOpen = visible"
                                :dropdownStyle="{ overflow: 'unset' }"
                                @select="(value, option) => onChangeSubTrackingId(value, option)">
                                <template #dropdownRender="{ menuNode: menu }">
                                    <v-nodes :vnodes="menu" />
                                    <template v-if="modelRef.primaryTrackingId">
                                        <a-divider style="margin: 8px 0" />
                                        <Editable :allow-clear="true" @callback="onAddSubTrackingId"
                                            :style="{ margin: '0 auto 4px' }" v-model:close="subSourceSelectOpen">
                                            <template #default="slotProps">
                                                <a href="javascript:;" class="source-edit" @click="slotProps.onClick">
                                                    <svg class="icon" aria-hidden="true"
                                                        style="font-size: 16px; margin-right: 8px;">
                                                        <use xlink:href="#icon-jiahao-cu"></use>
                                                    </svg>
                                                    <span>New Sub Tracking ID</span>
                                                </a>
                                            </template>
                                        </Editable>
                                    </template>
                                </template>
                                <template #suffixIcon>
                                    <svg class="icon" aria-hidden="true">
                                        <use xlink:href="#icon-jiantou-xia-cu"></use>
                                    </svg>
                                </template>
                            </a-select>
                        </div>
                    </div>
                    <!-- Source Options -->
                    <div class="source-options" style="margin-top: 32px">
                        <p class="sub-title" ref="zjdgx">
                            <span>Source Options</span>
                            <a-tooltip :getPopupContainer="() => $refs.zjdgx">
                                <template #title>
                                    A source is a method of classifying your links. For instance, a typical one
                                    could be
                                    a speciﬁc article ID or a domain name. You'll be capable of viewing a reporting
                                    breakdown for every source.
                                </template>
                                <svg class="icon" aria-hidden="true">
                                    <use xlink:href="#icon-wenhao-tianchong"></use>
                                </svg>
                            </a-tooltip>
                        </p>
                        <div class="option-item" ref="se">
                            <a-select :disabled="trackLinkId" :getPopupContainer="() => $refs.se" placeholder="All"
                                class="source-select artmisads-select" v-model:value="modelRef.sourceId"
                                :options="sourceOptions" ref="sourceSelect" :open="sourceSelectOpen"
                                @dropdownVisibleChange="visible => sourceSelectOpen = visible"
                                :dropdownStyle="{ overflow: 'unset' }" @change="onChangeTrackLink">
                                <template #dropdownRender="{ menuNode: menu }">
                                    <v-nodes :vnodes="menu" />
                                    <a-divider style="margin: 8px 0" />
                                    <Editable :allow-clear="true" @callback="onAddSourceOption"
                                        :style="{ margin: '0 auto 4px' }" v-model:close="sourceSelectOpen">
                                        <template #default="slotProps">
                                            <a href="javascript:;" class="source-edit" @click="slotProps.onClick">
                                                <svg class="icon" aria-hidden="true"
                                                    style="font-size: 16px; margin-right: 8px;">
                                                    <use xlink:href="#icon-jiahao-cu"></use>
                                                </svg>
                                                <span>New Soruce</span>
                                            </a>
                                        </template>
                                    </Editable>
                                </template>
                                <template #suffixIcon>
                                    <svg class="icon" aria-hidden="true">
                                        <use xlink:href="#icon-jiantou-xia-cu"></use>
                                    </svg>
                                </template>
                            </a-select>
                        </div>
                    </div>

                </div>
            </a-spin>
            <div class="link-footer">
                <template v-if="activeTab === '0'">
                    <artmisads-button :disabled="loading" class="save_copy" type="primary" @click.stop="onSaveAndCopy">
                        <svg class="icon" aria-hidden="true">
                            <use xlink:href="#icon-copy2-cu"></use>
                        </svg>
                        Save & Copy
                    </artmisads-button>
                    <artmisads-button :disabled="loading" class="save" type="primary" @click.stop="onSave">
                        <svg class="icon" aria-hidden="true">
                            <use xlink:href="#icon-baocun-cu"></use>
                        </svg>
                        Save
                    </artmisads-button>
                </template>
                <template v-if="activeTab === '1'">
                    <artmisads-button :disabled="loading || !associateModelRef.shortLink" class="save_copy"
                        type="primary" @click.stop="onSaveAndCopy">
                        <svg class="icon" aria-hidden="true">
                            <use xlink:href="#icon-copy2-cu"></use>
                        </svg>
                        Save & Copy
                    </artmisads-button>
                    <artmisads-button :disabled="loading || !associateModelRef.shortLink" class="save" type="primary"
                        @click.stop="onSave">
                        <svg class="icon" aria-hidden="true">
                            <use xlink:href="#icon-baocun-cu"></use>
                        </svg>
                        Save
                    </artmisads-button>
                </template>
            </div>
        </div>
    </artmisads-modal>
</template>

<script setup>
import { reactive, ref, computed, watch, watchEffect, defineComponent } from 'vue'
import { message } from 'ant-design-vue'
import { SaveOutlined, CopyOutlined, QuestionCircleOutlined, PlusOutlined } from '@ant-design/icons-vue'
import Editable from '~/components/Editable.vue'
import { trackingIdsApi } from "~/server/publisher/trackingIds"
import { associateTagsApi } from '@/server/publisher/associateTags'
import { useUserInfoStore } from '~/storeData/index'
const store = useUserInfoStore()
import { publisherProductApi } from '~/server/index'
import { useRouter } from 'vue-router'
const router = useRouter()
const open = defineModel('open')
const { productId, brandId, linkType, trackLinkId, countryCode, showAssociateTag, associateStatus, attributionStatus } = defineProps({  
    productId: { type: String, default: '' },
    brandId: { type: String, default: '' },
    linkType: { type: String, default: 'product' },
    trackLinkId: { type: Number, default: undefined },
    countryCode: { type: String, default: 'US' },
    showAssociateTag: { type: Boolean, default: false },
    associateStatus: { type: String, default: 'active' },
    attributionStatus: { type: String, default: 'active' },
})
const emit = defineEmits(['callback'])

const associateTagOptions = ref([])
const sourceSelectOpen = ref(false)
const modelRef = ref({})
const associateModelRef = ref({
    shortLinkSelect: true
})
//缓存 source options 下拉数据
const sourceOptions = ref([])
const newSourceName = ref()
const activeKey = ref(['collapse'])
const loading = ref(false)
import { useSystemStore } from '@/storeData/system'
const systemStore = useSystemStore()

const VNodes = defineComponent({
    props: {
        vnodes: {
            type: Object,
            required: true,
        },
    },
    render () {
        return this.vnodes
    },
})

const showTrackLink = computed(() => {
    let urlObj = new URLSearchParams(modelRef.value.trackingLink)
    modelRef.value.trackingLink = decodeURIComponent(urlObj.toString())
    return modelRef.value.trackingLink
})
const onFocusAssociateTag = (openModalParams) => {
    if(openModalParams){
        if(associateTagOptions.value.length === 0){
            getAssociateLinkList()
        }
    }
}
const onChangeTrackLink = async () => {
    let { productId, trackingLink, amazonTagSelect, sourceId, asin } = modelRef.value
    loading.value = true
    let { success, data, error } = await publisherProductApi.getTrackLinkByParams({ linkType, brandId, productId, countryCode, trackingLink, amazonTagSelect, sourceId, asin }).catch(e => ({ success: false, error: e.message }))
    if (success) {
        modelRef.value.adGroupId = data.adGroupId
        modelRef.value.trackingLink = data.trackingLink
    } else {
        message.error(error)
    }
    loading.value = false
}
// 缓存 primary tracking id 下拉数据
const primaryTrackingIdOptions = ref([])
const primarySourceSelectOpen = ref(false)
const onChangePrimaryTrackingId = async (value) => {
    getSubTrackingId()
    modelRef.value.subTrackingId = ''


}
const onAddPrimaryTrackingId = async (value) => {
    if (value.length > 20) {
        message.error('Exceeds length limit, please enter within 20 characters.')
        return
    }
    if (value && !/^[\u4e00-\u9fa50-9A-Za-z]+$/.test(value)) {
        message.error('Invalid format. Only Chinese characters, letters and numbers are allowed.')
        return
    }
    const { data, code } = await trackingIdsApi.addTrackingId({
        trackingId: value,
        // trackingId: sub?sub:undefined,
        trackingIdType: 'PRIMARY'
    })
    if (code == 6111) {
        message.error('Tracking ID already exists')
        return
    }
    getTrackingId()
}
// 缓存 sub tracking id 下拉数据
const subTrackingIdOptions = ref([])
const allSubTrackingIdOptions = ref([])
const subSourceSelectOpen = ref(false)
const onChangeSubTrackingId = async (value, option) => {
    if (!modelRef.value.primaryTrackingId) {
        subSourceSelectOpen.value = false
        modelRef.value.primaryTrackingId = option.parentId
        getSubTrackingId()
    }
}
const onAddSubTrackingId = async (value) => {
    if (value.length > 20) {
        message.error('Exceeds length limit, please enter within 20 characters.')
        return
    }
    if (value && !/^[\u4e00-\u9fa50-9A-Za-z]+$/.test(value)) {
        message.error('Invalid format. Only Chinese characters, letters and numbers are allowed.')
        return
    }
    await trackingIdsApi.addTrackingId({
        trackingId: value,
        parentId: modelRef.value.primaryTrackingId,
        trackingIdType: 'SUB'
    })
    getSubTrackingId()
    // getAllSubTrackingId()

}
const onAddSourceOption = async value => {
    if (value.trim()) {
        let { success, data, error } = await publisherProductApi.addSourceOption({ name: value.trim() }).catch(e => ({ success: false, error: e.message }))
        if (success) {
            sourceOptions.value.push({ label: data.name, value: data.id })
            modelRef.value.sourceId = data.id
            modelRef.value.sourceName = data.name
            sourceSelectOpen.value = false
            onChangeTrackLink()
        } else {
            message.error(error)
        }
    }
}

const cleanEmptyProperties = (obj) => {
    return Object.fromEntries(
        Object.entries(obj).filter(([_, value]) => {
            if (value === null || value === undefined || value === '') return false
            if (typeof value === 'object') return Object.keys(value).length > 0
            return true
        })
    )
}

const onSave = async () => {
    // const cleanedModelRef = cleanEmptyProperties(modelRef.value);
    if (activeTab.value === '0') {
        if (!modelRef.value.subTrackingId) {
            delete modelRef.value.subTrackingId
        }
        // console.log(modelRef.value,'modelRef.value')
        let subTrackingName = allSubTrackingIdOptions.value.find(item => {
            return item.value == modelRef.value.subTrackingId
        })?.label
        if (!subTrackingName) {
            subTrackingName = subTrackingIdOptions.value.find(item => {
                return item.value == modelRef.value.subTrackingId
            })?.label
        }
        const primaryTrackingName = primaryTrackingIdOptions.value.find(item => {
            return item.value == modelRef.value.primaryTrackingId
        })?.label
        modelRef.value.subTrackingId = subTrackingName
        modelRef.value.primaryTrackingId = primaryTrackingName
        // console.log(modelRef.value,'modelRef.value')
        // return
        let { success, data, error } = await publisherProductApi.saveGenerateLink(linkType, brandId, productId, countryCode, modelRef.value).catch(e => ({ success: false, error: e.message }))

        if (success) {
            emit('callback', {
                id: data.id,
                trackLinkId: data.id,
                linkMd5: data.linkMd5 || modelRef.value.linkMd5,
                trackingLink: data.trackingLink,
                shortLink: modelRef.value.shortLink,
                sourceName: getSourceNameFromOptions(),
                shortLinkSelect: modelRef.value.shortLinkSelect,
                amazonTagSelect: modelRef.value.amazonTagSelect || modelRef.value.amazonTagSelect,
            })
            message.success('Success!', 1)
        } else {
            message.error(error)
        }
    }
    if (activeTab.value === '1') {
        const { success, data, error } = await publisherProductApi.saveAssociateLink({
            productId,
            ...associateModelRef.value
        }).catch(e => ({ success: false, error: e.message }))
        if (success) {
            message.success('Success!', 1)
            emit('callback', {
                ...data,
                trackingLink: data.associateLink,
                trackLinkId: data.shortLinkId,

            })
        } else {
            message.error(error)
        }
    }

}

function getSourceNameFromOptions () {
    for (const source of sourceOptions.value) {
        if (source.value == modelRef.value.sourceId) {
            return source.label
        }
    }

    return ''
}

const onSaveAndCopy = async () => {
    try {
        await activeTab.value === '0' ? navigator.clipboard.writeText(modelRef.value.shortLinkSelect ? modelRef.value.shortLink : modelRef.value.trackingLink) : navigator.clipboard.writeText(associateModelRef.value.shortLinkSelect ? associateModelRef.value.shortLink : associateModelRef.value.associateLink)
        onSave()
    } catch (error) {
        message.success('Failed!', 1)
    }
}
const getTrackingId = async () => {
    let { success, data, error } = await trackingIdsApi.getTrackingIds({ page: 1, size: 10000 }).catch(e => ({ success: false, error: e.message }))
    if (success) {
        primaryTrackingIdOptions.value = data.data.map(item => {
            return {
                label: item.trackingId,
                value: String(item.id),
                subTrackingIds: item.subTrackingIds

            }
        })
    } else {
        message.error(error)
    }

}
const getSubTrackingId = async () => {
    let { success, data, error } = await trackingIdsApi.getSubTrackingIds(modelRef.value.primaryTrackingId).catch(e => ({ success: false, error: e.message }))
    if (success) {
        subTrackingIdOptions.value = data.map(item => {
            return {
                label: item.trackingId,
                value: String(item.id),
            }
        })
    } else {
        message.error(error)
    }
}
const getAllSubTrackingId = async () => {
    subTrackingIdOptions.value = []
    primaryTrackingIdOptions.value.forEach(item => {
        if (item.subTrackingIds.length > 0) {
            item.subTrackingIds.forEach(subItem => {
                subTrackingIdOptions.value.push({
                    label: subItem.trackingId,
                    value: String(subItem.id),
                    parentId: String(item.value)
                })
            })
        }
    })
    allSubTrackingIdOptions.value = JSON.parse(JSON.stringify(subTrackingIdOptions.value))
}
const resetAssociateModelRef = () => {
    associateModelRef.value.shortLinkSelect = true
    associateModelRef.value.associateLink = ''
    associateModelRef.value.shortLink = ''
    associateModelRef.value.associateTag = ''
}
const onUploadAssociateTag = () => {
    window.open('/publisher/settings/associateTags','_blank')
  
}
watch(open, async open => {
    if (open) {
        // activeTab.value = '0'
      
        loading.value = true
        resetAssociateModelRef()

        if (showAssociateTag) {
          
            activeTab.value = '0'
          
            if (linkType == 'product' || linkType == 'brand') {
                programConfig.value = [
                    {
                        label: 'Attribution Link',
                        key: '0',
                    },
                ]
                if (trackLinkId) {
                    let { success, data, error } = await publisherProductApi.getTrackDetailByTrackLinkId({ linkType, trackLinkId }).catch(e => ({ success: false, error: e.message }))
                    if (success) {
                        modelRef.value = data

                    } else {
                        message.error(error)
                    }
                } else {
                    const params = { countryCode }

                    if (linkType === 'product') {
                        params.productId = productId
                    } else {
                        params.brandId = brandId
                    }

                    let { success, data, error } = await publisherProductApi[`getTrackDetailBy${linkType === 'product' ? 'Product' : 'Brand'}Id`](params).catch(e => ({ success: false, error: e.message }))

                    if (success) {
                        modelRef.value = data
                    } else {
                        message.error(error)
                    }
                }
            }
            if (linkType == 'associate') {

                activeTab.value = '1'
                programConfig.value = [
                    {
                        label: 'Associate Link',
                        key: '1',
                    },
                ]
            }
        } else {
          if (attributionStatus === 'active') {
                    activeTab.value = '0'
                } else {
                    activeTab.value = '1'
                }
            if (store.userInfo.associateEnabled == 'Y') {
               if(associateStatus === 'active'&&attributionStatus === 'active'){
                programConfig.value = [
                    {
                        label: 'Attribution Link',
                        key: '0',
                    },
                    {
                        label: 'Associate Link',
                        key: '1',
                    },
                ]
               }
                if(associateStatus === 'active'&&attributionStatus === 'inactive'){
                    activeTab.value = '1'
                     programConfig.value = [
                    
                    {
                        label: 'Associate Link',
                        key: '1',
                    },
                ]
                }
                if(associateStatus === 'inactive'&&attributionStatus === 'active'){
                    activeTab.value = '0'
                     programConfig.value = [
                     {
                        label: 'Attribution Link',
                        key: '0',
                    },
                ]
                }
            } else {
                programConfig.value = [
                    {
                        label: 'Attribution Link',
                        key: '0',
                    },
                ]
            }

            if (trackLinkId) {
                let { success, data, error } = await publisherProductApi.getTrackDetailByTrackLinkId({ linkType, trackLinkId }).catch(e => ({ success: false, error: e.message }))
                if (success) {
                    modelRef.value = data

                } else {
                    message.error(error)
                }
            } else {
                const params = { countryCode }

                if (linkType === 'product') {
                    params.productId = productId
                } else {
                    params.brandId = brandId
                }
                if(attributionStatus === 'active'){
 let { success, data, error } = await publisherProductApi[`getTrackDetailBy${linkType === 'product' ? 'Product' : 'Brand'}Id`](params).catch(e => ({ success: false, error: e.message }))

                if (success) {
                    modelRef.value = data
                } else {
                    message.error(error)
                }
                }
               
            }
        }



        // 缓存 primary tracking id 下拉数据
        if (!primaryTrackingIdOptions.value.length) {
            await getTrackingId()
        }
        await getAllSubTrackingId()
        const primaryTrackingName = modelRef.value.primaryTrackingId
        const subTrackingName = modelRef.value.subTrackingId
        modelRef.value.primaryTrackingId = primaryTrackingIdOptions.value.find(item => {
            return item.label == primaryTrackingName
        })?.value
        modelRef.value.subTrackingId = allSubTrackingIdOptions.value.find(item => {
            return item.label == subTrackingName && item.parentId == modelRef.value.primaryTrackingId
        })?.value
        if (!sourceOptions.value.length) {
            let { success, data, error } = await publisherProductApi.getSourceOptionsByPublisher().catch(e => ({ success: false, error: e.message }))
            if (success) {
                let options = data.map(item => ({ label: item.name, value: item.id }))
                sourceOptions.value = options
            } else {
                message.error(error)
            }
        }
        const associateLink = programConfig.value.find(item => item.key == '1')
        if(associateLink){
            await getAssociateLinkList()
        }

        loading.value = false

    }
})
const activeTab = ref('0')
const programConfig = ref([])

const getAssociateLinkList = async () => {
    let { success, data, error } = await associateTagsApi.getAssociateTagsByCountryCode({ countryCode: countryCode }).catch(e => ({ success: false, error: e.message }))
    if (success) {
        // console.log(data, 'data')
        associateTagOptions.value = data?.associateTags
            .map(item => ({ label: item, value: item }))||[]
            if(data?.lastUsedAssociateTag){
                associateModelRef.value.associateTag = data?.lastUsedAssociateTag
                
            }
    } else {
        message.error(error)
    }
}
const onChangeAssociateTag = async (value) => {
    if (!value) {
        resetAssociateModelRef()
        return
    }

}
const onGenerateAssociateLink = async () => {
    if (!associateModelRef.value.associateTag) {

        return
    }
    if (associateModelRef.value.shortLink) {
        const { success, data, error } = await publisherProductApi.getAssociateLinkByParams({ productId, associateTag: associateModelRef.value.associateTag, trackingLink: associateModelRef.value.associateLink }).catch(e => ({ success: false, error: e.message }))
        if (success) {
            associateModelRef.value.associateLink = data.associateLink
        } else {
            message.error(error)
        }
    } else {
        const { success, data, error } = await publisherProductApi.initAssociateLink({ productId, associateTag: associateModelRef.value.associateTag }).catch(e => ({ success: false, error: e.message }))
        if (success) {
            associateModelRef.value = data

        } else {
            message.error(error)
        }
    }
}
watchEffect(async () => {
    if (open.value) {

    } else {
        activeKey.value = []
    }
})

</script>

<style scoped lang="less">
.upload-associate-tag {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
}

.generate-btn {
    height: 32px !important;
    padding: 0 20px !important;
    left: 32px !important;
    margin-left: -33px !important;
}

.link-tool {
    .title {
        display: block;
    }

    :deep(.ant-modal-body) {
        padding: 24px;
    }

    .link-scroll-area {
        cursor: not-allowed;
        user-select: none;
        min-height: 80px;
        border-radius: 8px;
        padding: 8px 12px;
        box-sizing: border-box;
        border: 1px solid #CCC7D9;
        background-color: #EEEDF2;
        box-shadow: 0 1px 0 0 var(--box-shadow-2);
    }

    .link-textarea {
        height: 102px;
        overflow-y: auto;
        line-height: 18px;
        word-break: break-word;

        button {
            position: absolute;
            right: 10px;
            top: 10px
        }
    }

    .link-short-link {
        margin: 8px 0 16px;
        color: var(--dark-2);
        text-align: right;

        :deep(.ant) {
            &-checkbox+span {
                font-weight: normal;
                color: var(--dark-2);
                font-size: 14px;
            }
        }
    }

    .link-collapse {

        :deep([aria-expanded="true"]) {
            .icon {
                transform: rotate(180deg);
            }
        }

        .link-collapse-header {
            display: flex;
            align-items: center;
            height: 20px;

            >span {
                font-weight: 500;
                color: var(--dark-2);
            }

            .icon {
                font-size: 14px;
                margin-left: 8px;
                color: var(--dark-2);
            }
        }

        :deep(.ant-collapse-header) {
            padding: 0;
        }

        :deep(.ant-collapse-content) {
            margin-top: 6px;
            background-color: #F8F7FC;
            border-radius: 8px
        }
    }

    .link-footer {
        margin-top: 26px;
        display: flex;
        width: 100%;
        padding-top: 12px;
        gap: 8px;
        flex-direction: row-reverse;
        position: relative;

        &::after {
            content: '';
            display: block;
            height: 1px;
            background: var(--border-4);
            position: absolute;
            left: -24px;
            top: 0px;
            width: calc(100% + 48px);
        }

        .save_copy,
        .save {
            svg {
                margin-right: 8px;
                font-size: var(--font-size-large)
            }
        }

        .save {
            color: var(--primary-text);
            background-color: var(--upload-bg);
        }

        // .save_copy {
        //     color: var(--dark-1);
        //     background: var(--yellow-1);
        // }
    }

    .source {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;

        .source-options {
            width: 40%;
        }

        .sub-title {
            display: flex;
            align-items: center;
            color: var(--dark-2);
            font-weight: 500;
            font-size: 14px;

            .icon {
                font-size: 14px;
                margin-left: 5px;
                color: var(--dark-4);
            }

            :deep(.ant-tooltip-inner) {
                font-size: 13px;
                padding: 6px 12px !important;
                line-height: 18px;
                min-width: 300px !important;
            }
        }

        .option-item {
            margin-top: 8px;

            .tracking-tag {
                display: flex;
                flex-direction: column;
                gap: 4px;

                label {
                    display: inline-flex;
                    align-items: center;
                    color: var(--dark-2);
                    font-weight: 400;
                    font-size: 14px;
                    height: 20px;
                }

                a {
                    margin-left: 24px;
                    text-decoration: underline;
                    color: var(--dark-3);
                    font-size: 12px;
                    font-weight: 400;
                    display: block;
                    padding-bottom: 8px;
                }
            }

            .track-tag-input {
                display: block;
                margin: 6px 0 0 24px;
                width: 251px;
                height: 32px;
                padding: 0 11px;
                position: relative;
                background-color: var(--color-white);
                border: 1px solid #d9d9d9;
                transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
                box-sizing: border-box;
                font-size: 14px;
                line-height: 1.5714285714285714;
                list-style: none;
                display: flex;
                border-radius: 8px;
                color: var(--dark-1);

                &:focus {
                    outline: none;
                    border: 1px solid var(--primary-border-2) !important;
                    box-shadow: var(--section-box-shadow-4) !important;
                }
            }

            .source-select {
                display: block;
                min-width: 200px;
            }

            .add-source {
                margin: 6px 0 0 24px;
            }
        }

    }


    .option-item {
        :deep(.ant-select) {
            &-disabled {
                .ant-select-selector {
                    background: var(--bg-gray-2);
                    box-shadow: var(--section-box-shadow-2);
                    border: 1px solid var(--border-1) !important;

                    .ant-select-selection-item {
                        color: var(--dark-4);
                    }
                }

                &:hover .ant-select-selector {
                    border-color: var(--border-1);
                }
            }

            &-item {
                margin: 0 4px;
                font-weight: 400;
                color: var(--dark-1);

                &:hover {
                    background: var(--bg-gray-6);
                }

                &:active {
                    background: var(--bg-gray-4);
                }

                &-option-selected {
                    position: relative;
                    font-weight: normal;
                    background-color: var(--select-bg-1);

                    &::after {
                        top: 8px;
                        right: 8px;
                        width: 16px;
                        height: 16px;
                        content: '';
                        position: absolute;
                        background: url(../../../../assets/images/svg/select_gou.png);
                        background-size: 100%;
                    }
                }
            }
        }
    }

}

.source-edit {
    position: relative;
    cursor: pointer;
    margin: 0 auto;
    display: flex;
    color: var(--dark-2);
    background-color: var(--bg-gray-1);
    width: 260px;
    height: 32px;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    border: 1px dashed var(--border-1);
}
</style>